const e = {
  name: "Payout",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5C0 4.44772 0.447715 4 1 4H21C22.6523 4 24 5.34772 24 7V17C24 18.6523 22.6523 20 21 20H4C3.44772 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18H21C21.5477 18 22 17.5477 22 17V7C22 6.45228 21.5477 6 21 6H1C0.447715 6 0 5.55228 0 5Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 12C8 9.79772 9.79772 8 12 8C14.2023 8 16 9.79772 16 12C16 14.2023 14.2023 16 12 16C9.79772 16 8 14.2023 8 12ZM12 10C10.9023 10 10 10.9023 10 12C10 13.0977 10.9023 14 12 14C13.0977 14 14 13.0977 14 12C14 10.9023 13.0977 10 12 10Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 11.2C17.4477 11.2 17 11.6477 17 12.2C17 12.7523 17.4477 13.2 18 13.2H19C19.5523 13.2 20 12.7523 20 12.2C20 11.6477 19.5523 11.2 19 11.2H18Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 10C1 9.44772 1.44772 9 2 9H5C5.55228 9 6 9.44772 6 10C6 10.5523 5.55228 11 5 11H2C1.44772 11 1 10.5523 1 10Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 13C2.44772 13 2 13.4477 2 14C2 14.5523 2.44772 15 3 15H6C6.55228 15 7 14.5523 7 14C7 13.4477 6.55228 13 6 13H3Z" />
    </svg>
  `
};
export {
  e as Payout
};
